import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { trendSplineConfig } from "../Highcharts/chartconfig";
import ChartComponent from "../Highcharts/ChartComponent";
import axios from "axios";
import Loader from "./Loader";

function TrendCases({ requestData }) {
  const [trendChartData, setTrendChartData] = useState(null);
  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
    };
    if (Object.keys(requestData).length > 0) {
      let filterRequest = {};
      if (
        requestData.hasOwnProperty("questionIds") &&
        requestData.hasOwnProperty("selectedOption")
      ) {
        filterRequest.questionIds = requestData.questionIds;
        filterRequest.selectedOption = requestData.selectedOption;
      }

      if (
        requestData.hasOwnProperty("subQuestionIds") &&
        requestData.hasOwnProperty("selectedOption")
      ) {
        filterRequest.subQuestionIds = requestData.subQuestionIds;
        filterRequest.selectedOption = requestData.selectedOption;
      }

      if (requestData.hasOwnProperty("serviceIdFilter")) {
        filterRequest.serviceIdFilter = requestData.serviceIdFilter;
      }

      let oRequest = { ...requestBody, ...filterRequest };
      getTrendChartData(oRequest);
    } else {
      getTrendChartData(requestBody);
    }
  }, [requestData]);

  let getTrendChartData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/getCasesReportedOverTime`,
        data
      );
      let formatedData = res.data.data.casesReportedOverTime;
      let catagoriesArr = Object.keys(formatedData).reverse();
      let chartValues = Object.values(formatedData).reverse();
      let obj = {
        catagoriesArr,
        chartValues,
      };
      setTrendChartData(obj);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Card>
      <Card.Body className="pb-3">
        <h5>Trend of cases reported over time</h5>
        {trendChartData !== null ? (
          <ChartComponent options={trendSplineConfig(trendChartData)} />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default TrendCases;
